import { jsx as _jsx } from "react/jsx-runtime";

function SvgReturns() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.984 9.167a8.504 8.504 0 0113.21-3.896c.736.569 2.09 1.83 3.28 2.969.485.464.938.903 1.304 1.26H19a.5.5 0 000 1h4a.498.498 0 00.5-.5V6a.5.5 0 00-1 0v2.808c-.372-.363-.836-.814-1.334-1.29-1.18-1.13-2.575-2.43-3.36-3.038A9.504 9.504 0 003.04 8.833a.5.5 0 10.943.334zM.5 13.997a.5.5 0 01.5-.5h4a.5.5 0 010 1H2.22c.366.358.82.798 1.305 1.263 1.19 1.139 2.545 2.4 3.28 2.969a8.504 8.504 0 0013.21-3.896.5.5 0 11.944.334A9.504 9.504 0 016.194 19.52c-.785-.607-2.18-1.908-3.36-3.037a189.03 189.03 0 01-1.334-1.29v2.805a.5.5 0 01-1 0v-4zm11.347-6.306a.409.409 0 01.403-.004l3.1 1.71-3.304 1.86-3.163-1.846 2.964-1.72zm.694 4.435v3.699l3.04-1.736a.41.41 0 00.206-.355v-3.435l-3.246 1.827zm-1-.005v3.703L8.506 14.09a.41.41 0 01-.206-.355v-3.506l3.241 1.893zm1.192-5.31a1.409 1.409 0 00-1.388.015l-3.343 1.94A1.41 1.41 0 007.3 9.985v3.749c0 .506.27.972.71 1.223l3.332 1.905a1.41 1.41 0 001.398 0l3.336-1.905c.44-.25.71-.717.71-1.223V9.88c0-.513-.278-.986-.728-1.234l-3.325-1.835z"
    }, void 0)
  }), void 0);
}

export default SvgReturns;